// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditFulfillmentOrderProperty } from '@/audit/api/types';
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { Link } from '@/components/link';
import { ArrowForwardRounded } from '@/constants/hardfin-standard-icons';
import { Typography } from '@mui/material';

interface Props {
  property: AuditFulfillmentOrderProperty;
}

interface FulfillmentOrderValue {
  key: string;
  foNumber: string;
}

/**
 * Renders a fulfillment order reference as a link to its detail page. A null
 * reference (the order was cleared) renders as the usual empty value.
 */
function FulfillmentOrderValueLabel(props: {
  value: FulfillmentOrderValue | null | undefined;
}) {
  if (!props.value) {
    return <AuditPropertyValue value={null} />;
  }

  return (
    <Link
      to="/fulfillments/$fulfillmentKey"
      params={{ fulfillmentKey: props.value.key }}
      variant="inherit"
    >
      {props.value.foNumber}
    </Link>
  );
}

export function AuditFulfillmentOrderLabel(props: Props) {
  if (props.property.oldValue === undefined) {
    return (
      <Typography display="flex" variant="caption" alignItems="center">
        <Typography component="span" variant="inherit" fontWeight="bold">
          {props.property.name}:&nbsp;
        </Typography>
        <FulfillmentOrderValueLabel value={props.property.newValue} />
      </Typography>
    );
  }

  return (
    <Typography display="flex" variant="caption" alignItems="center">
      <Typography component="span" variant="inherit" fontWeight="bold">
        {props.property.name}:&nbsp;
      </Typography>
      <FulfillmentOrderValueLabel value={props.property.oldValue} />
      <ArrowForwardRounded fontSize="inherit" sx={{ marginX: 1 }} />
      <FulfillmentOrderValueLabel value={props.property.newValue} />
    </Typography>
  );
}
